// extracted by mini-css-extract-plugin
module.exports = {"iconCheck":"style_iconCheck__3eHnV","orderComment":"style_orderComment__2oOuA","resolutionComment":"style_resolutionComment__3QEMR","commentLabel":"style_commentLabel__11VGW"};